import { find, pick } from 'lodash';

class TreatmentsSelectController {

    constructor(treatmentsService, messageService) {
        this.treatmentsService = treatmentsService;
        this.messageService = messageService;
    }

    $onInit () {
        this.placeholder = this.placeholder || 'Treatments';
        this.value = this.value || [];
        this.treatmentsService.findAll(-1)
            .then(treatments => {
                this.treatments = treatments;
                if (this.value.length) {
                    for (let i in this.value) {
                        this.value[i] = find(this.treatments, { 'id': this.value[i].treatment_id });
                    }
                }
            })
            .catch(errors => {
                this.messageService.failure(errors);
                this.messageService.push();
            });
    }
}

TreatmentsSelectController.$inject = ['treatmentsService', 'messageService'];

export default TreatmentsSelectController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/controllers/treatments.select.controller.js